import {Component, inject, ViewChild, ChangeDetectionStrategy} from '@angular/core';

import {CdkAccordion, CdkAccordionItem} from '@angular/cdk/accordion';
import {EnergyStatusComponent} from './components/energy-status/energy-status.component';
import {LiveChartComponent} from './components/live-chart/live-chart.component';
import {WeatherTodayComponent} from './components/weather-today/weather-today.component';
import {WeatherTomorrowComponent} from './components/weather-tomorrow/weather-tomorrow.component';
import {EnergyPriceCurrentComponent} from './components/energy-price-current/energy-price-current.component';
import {EnergyPriceMarketComponent} from './components/energy-price-market/energy-price-market.component';
import {MatIcon} from '@angular/material/icon';
import {MatButtonToggle, MatButtonToggleGroup} from '@angular/material/button-toggle';
import {DailyBalanceComponent} from './components/energy-balance/day/daily-balance.component';
import {StartpageOptionService} from './utils/startpage-option.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  imports: [
    CdkAccordion,
    CdkAccordionItem,
    EnergyStatusComponent,
    LiveChartComponent,
    WeatherTodayComponent,
    WeatherTomorrowComponent,
    EnergyPriceCurrentComponent,
    EnergyPriceMarketComponent,
    MatIcon,
    MatButtonToggle,
    MatButtonToggleGroup,
    DailyBalanceComponent,
    RouterLink
],
  templateUrl: './dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dashboard.component.css',
})
export class DashboardComponent {

  @ViewChild('accordionItem') accordionItem!: CdkAccordionItem;

  private optionService = inject(StartpageOptionService);
  selectedStartpageoption = this.optionService.selectedStartpageoption;

  onSwitchToggle(event: any) {
    this.optionService.setOption(event.value);
  }

  ngAfterViewInit() {
    // Expand the accordion item by default
    this.accordionItem.expanded = true;
  }

  get chartLinkText(): string {
    return this.selectedStartpageoption() === 'Status' ? '/energy-chart' : '/energy-balance';
  }
}

